<template>
  <section>
    <h3>
      <a href="/pedagogico/convenios">
        <v-icon>card_giftcard</v-icon>Convênios
      </a>
    </h3>
    <p>As vantagens e descontos exclusivos por ser aluno da Escola Engenho.</p>

    <p style="text-align:right !important;">
      <v-btn href="/pedagogico/convenios" small depressed outline round color="primary">ver mais</v-btn>
    </p>
  </section>
</template>

<script>
export default {
  data: () => ({})
};
</script>

<style lang="scss" scoped>
p,
h2,
ul li,
ol li {
  text-align: left !important;
}
</style>



